import { useEffect, useState } from 'react';

import useBreakpoints from '@/hooks/use-breakpoints';

import HygraphImage, { HygraphImageProps } from '@/components/hygraph-image';

export type ResponsiveHygraphImageProps = {
  desktopImage: HygraphImageProps;
  mobileImage?: HygraphImageProps;
} & Pick<
  HygraphImageProps,
  'imgClassName' | 'fill' | 'roundedCorners' | 'containerClassName'
>;

const ResponsiveHygraphImage = ({
  desktopImage,
  mobileImage,
  ...rest
}: ResponsiveHygraphImageProps) => {
  // Using js breakpoint to pick image, because both images will be downloaded otherwise
  // A work around for this would be to do lazy load, but we need eager for hero
  //
  // The issue with this approach is that on load, the breakpoint is not known yet and is
  // set to md.  This means on lg screen, the md is loaded and then the lg is loaded.
  // A possible solution is to from using Next/Image and use  <picture>/<source>
  //
  // There is a way to use <picture> and Next/Image, but its not released yet:
  // https://github.com/vercel/next.js/discussions/19880#discussioncomment-6310787
  // more discussion about this: https://github.com/vercel/next.js/discussions/25393
  //
  // Could also look into this other library that sits on top of next/image
  // https://github.com/humaans/next-img
  // https://www.npmjs.com/package/next-img

  // Because we dont know the browser width until mount, we want to wait until mount
  //  to render the image so we know its the right version
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);

  const { currentEntry: currentBackgroundImage } = useBreakpoints({
    md: mobileImage || desktopImage,
    lg: desktopImage,
  });

  if (!isMounted) {
    return null;
  }

  return <HygraphImage {...rest} {...currentBackgroundImage} />;
};

export default ResponsiveHygraphImage;
